import { Pipe, PipeTransform } from '@angular/core';
import { Partner } from '../models/entities/master-data/partner-entity';


@Pipe({
  name: 'partner-pipe'
})

export class PartnerPipe implements PipeTransform {
  
  constructor(){}

      
progressLevels = [  
  {'id' : '0',  'name' : '  0 -  Nouveau'                  },
  {'id' : '10',  'name' : ' 10 -  Validé'                   },
]   


  transform(partner: Partner, field: string): any {
    let result = partner[field];

    let html = "<div class='multi-labels'>";


      if (partner.hold) {
        html += "<div class='label-red'> bloqué </div>"
      }
      if (partner.progressLevel < 10) {
        html += "<div class='label-orange'> Nouveau prospect </div>"
      }
      if (partner.partnerStatusCode == "-1") {
        html += "<div class='label-green'> A recenser </div>"
      }
      html += "</div>";
      result = html;
    


    return result;
  }
}
